import Table from './Table';
export type {
  TableProps,
  ColumnProps,
  ColumnGroupProps,
  HeaderCellProps,
  SortType,
  RowDataType,
  RowKeyType,
  TableLocaleType,
  TableSizeChangeEventName,
  TableInstance
} from 'rsuite-table';

export type { CellProps } from './Table';

export default Table;
